import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { oldWay, newWay, comparison, media } from '../data/product';
import { GuaranteeStrip, ShopHotspot } from './BannerOverlays';
export function ProblemSection() {
  return <section id="why" className="border-b border-white/10 bg-ink-950" data-id="element-699" data-mp="30j0w7fr6mz7u">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-700" data-mp="2vowj0erbpuyb">
        <h2 className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-701" data-mp="39gkv4i1kojfa">
          Your headlamp
          <br data-id="element-702" data-mp="3jg20eycwwvaq" />
          <span className="text-grit-500" data-id="element-703" data-mp="3jftq9e86c438">just evolved.</span>
        </h2>
        <div className="mt-5 max-w-2xl space-y-3 text-[15px] leading-relaxed text-steel-300 sm:text-lg" data-id="element-704" data-mp="3jdpmqxe6t73h">
          <p data-id="element-705" data-mp="1p2134hx0ggcr">For years, hands-free light meant strapping another piece of gear around your head.</p>
          <p className="font-semibold text-offwhite" data-id="element-706" data-mp="1k2xwwu5ao437">Not anymore.</p>
          <p data-id="element-707" data-mp="1k4simaoe408c">
            GritVue X1 combines wearable illumination and interchangeable work lenses into one compact piece of
            gear.
          </p>
        </div>

        <p className="mt-8 border-l-4 border-grit-500 pl-4 font-display text-[clamp(1.5rem,5vw,2.5rem)] font-extrabold uppercase leading-tight text-grit-500" data-id="element-708" data-mp="od9hybxl8cd7">
          Less gear. More visibility. Both hands free.
        </p>

        <div className="mt-10 grid gap-px bg-white/10 lg:grid-cols-2" data-id="element-709" data-mp="x5t96rbjveo0">
          <div className="bg-ink-900 p-6 lg:p-8" data-id="element-710" data-mp="122jqtj306ibj">
            <p className="font-display text-2xl font-bold uppercase tracking-wide text-steel-400" data-id="element-711" data-mp="125z3kf97ff9s">Old way</p>
            <ul className="mt-5 grid gap-3" data-id="element-712" data-mp="1c1spuqcq6n4r">
              {oldWay.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-steel-400 sm:text-base" data-id="element-713" data-mp="1bzy6vhl0l53b">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-steel-500" aria-hidden="true" data-id="element-714" data-mp="3dt5jukd5nam1" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-ink-900 p-6 ring-1 ring-inset ring-grit-500/50 lg:p-8" data-id="element-715" data-mp="3hwkbk8aghffb">
            <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-grit-500" data-id="element-716" data-mp="p2d2g29ajvbn">GritVue X1</p>
            <ul className="mt-5 grid gap-3" data-id="element-717" data-mp="k3imd82pkkv8">
              {newWay.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium text-offwhite sm:text-base" data-id="element-718" data-mp="xyuh3fgv6bc5">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-719" data-mp="17z4sqvn93ap7" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 border border-white/10 bg-ink-900" data-id="element-720" data-mp="1hooec92clinr">
          <div className="hidden grid-cols-[1.1fr_1fr_1fr] border-b border-white/10 bg-ink-850 sm:grid" data-id="element-721" data-mp="1ho4ycxw9d4cd">
            <div className="px-3 py-3.5 font-display text-base font-bold uppercase tracking-wide text-steel-400 sm:px-6 sm:text-lg" data-id="element-722" data-mp="1crxwphawaf08">
              Head to head
            </div>
            <div className="border-l border-white/10 px-3 py-3.5 font-display text-base font-bold uppercase tracking-wide text-steel-400 sm:px-6 sm:text-lg" data-id="element-723" data-mp="1ls4al4ai9gzx">
              Other work lights
            </div>
            <div className="border-l border-grit-500/40 bg-grit-500/10 px-3 py-3.5 font-display text-base font-extrabold uppercase tracking-wide text-grit-500 sm:px-6 sm:text-lg" data-id="element-724" data-mp="2aamq4zhoq5su">
              GritVue X1
            </div>
          </div>
          {comparison.map(row => <div key={row.point} className="border-b border-white/5 last:border-b-0 sm:grid sm:grid-cols-[1.1fr_1fr_1fr]" data-id="element-725" data-mp="1ml1vvkg2zm49">
              <div className="bg-ink-850 px-4 py-3 text-[13px] font-bold uppercase tracking-wide text-offwhite sm:bg-transparent sm:px-6 sm:py-4 sm:font-semibold sm:text-sm" data-id="element-726" data-mp="1cnxfk18x2kvd">
                {row.point}
              </div>
              <div className="flex items-start gap-2 px-4 py-3 text-[13px] text-steel-400 sm:border-l sm:border-white/10 sm:px-6 sm:py-4 sm:text-sm" data-id="element-727" data-mp="13o0ndpnbj3vk">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-steel-500" aria-hidden="true" data-id="element-728" data-mp="18nvdhqz9rpfk" />
                <span data-id="element-729" data-mp="10n7abo6zujjg">
                  <span className="mr-1 font-bold uppercase text-steel-500 sm:hidden" data-id="element-730" data-mp="vmjmfbe2aitg">Others:</span>
                  {row.others}
                </span>
              </div>
              <div className="flex items-start gap-2 bg-grit-500/[0.06] px-4 py-3 text-[13px] font-medium text-steel-200 sm:border-l sm:border-grit-500/40 sm:px-6 sm:py-4 sm:text-sm" data-id="element-731" data-mp="qtgs311gn5c7">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grit-500" aria-hidden="true" data-id="element-732" data-mp="hw6f9b8zv856" />
                <span data-id="element-733" data-mp="cugz5h6x04a8">
                  <span className="mr-1 font-bold uppercase text-grit-500 sm:hidden" data-id="element-734" data-mp="cy4saf8g6oof">X1:</span>
                  {row.gritVue}
                </span>
              </div>
            </div>)}
        </div>

        <figure className="relative mt-10" data-id="element-735" data-mp="22agfpjcv4vzw">
          <img src={media.versusSheet} alt="A traditional strap headlamp shown next to the GritVue X1 illuminated work glasses" className="block h-auto w-full border border-white/10" data-id="element-736" data-mp="229f67jbhwhka" />
          <ShopHotspot box={{
          left: '78.1%',
          top: '86.6%',
          width: '20.7%',
          height: '7.6%'
        }} data-id="element-737" data-mp="3g4negyeshvp8" />
          <GuaranteeStrip data-id="element-738" data-mp="3l3qa5s8vqpkj" />
        </figure>

        <div className="mt-8" data-id="element-739" data-mp="3pwb2sqg1uwmh">
          <CtaButton className="w-full sm:w-auto" data-id="element-740" data-mp="3px30q7x4d6fx">See the X1</CtaButton>
        </div>
      </div>
    </section>;
}